import type { Team } from '../../api/teams'

export function canViewTeamCredits(team: Team | null | undefined): boolean {
  return team?.myRole === 'owner' || team?.myRole === 'admin'
}
